import type { ColorScheme } from '@vis.gl/react-google-maps';

import type { Theme } from '@/context/ThemeContext';

/** Maps the app theme to the Google Maps color scheme so every map follows the UI theme. */
export const googleThemeMapping: Record<Theme, ColorScheme> = {
	light: 'LIGHT',
	dark: 'DARK',
	system: 'FOLLOW_SYSTEM',
};
